import * as FileSystem from 'expo-file-system';
import { ArticleJSON, JobEntry } from './Datatypes';

export const readLocalJsonFile = async <T>(filePath: string): Promise<T | null> => {
  try {
    const jsonString = await FileSystem.readAsStringAsync(filePath);
    const jsonObject = JSON.parse(jsonString);
    return jsonObject as T;
  } catch (error) {
    console.error('Error reading JSON file:', error);
    return null;
  }
};

export const findArticleByJobId = async (
  filePath: string,
  jobId: string
): Promise<ArticleJSON | null> => {
  try {
    const jsonString = await FileSystem.readAsStringAsync(filePath);
    const jsonArray: JobEntry[] = JSON.parse(jsonString);

    if (!Array.isArray(jsonArray)) {
      console.error('Invalid JSON structure: Expected an array.');
      return null;
    }

    const job = jsonArray.find((job) => job.id === jobId);

    if (!job) {
      console.error(`No job found with jobId: ${jobId}`);
      return null;
    }
    //console.log(JSON.stringify(job.articleData, null, 2))
    return job.articleData;
  } catch (error) {
    console.error('Error reading or parsing JSON file:', error);
    return null;
  }
};